import { find } from 'lodash';
var SignalTypes;
(function (SignalTypes) {
    SignalTypes["ConstraintsApplied"] = "constraintsApplied";
    SignalTypes["State"] = "state";
})(SignalTypes || (SignalTypes = {}));
export class TokboxSignalService {
    constructor(videoProvider, OTSession, $log) {
        this.videoProvider = videoProvider;
        this.OTSession = OTSession;
        this.debug = $log.debug.bind($log, 'TokboxSignalService:');
    }
    onSignal(e) {
        this.debug('onSignal', e);
        try {
            const data = JSON.parse(e.data);
            const signalType = data.type;
            const connection = find(this.videoProvider.connections, {
                id: e.from.connectionId,
            });
            if (!connection) {
                // TODO HANDLE THAT CASE
                console.error('TokboxSignalService:onSignal:no-connection', e);
                return;
            }
            switch (signalType) {
                case SignalTypes.ConstraintsApplied:
                    this.onSignalConstraintsApplied(connection);
                    break;
                case SignalTypes.State:
                    this.onSignalState(connection, data.state);
                    break;
                default:
                    return;
            }
        }
        catch (e) {
            console.error('TokboxSignalService:onSignal:error', e);
        }
    }
    updateState(state, to) {
        this.send({ type: SignalTypes.State, state }, to);
    }
    signalVideoConstraintsApplied() {
        this.send({ type: SignalTypes.ConstraintsApplied });
    }
    send(data, to) {
        this.debug('send', data, to);
        const signalData = { data: JSON.stringify(data) };
        if (to) {
            signalData.to = to;
        }
        if (this.videoProvider.isInCall) {
            this.OTSession.session.signal(signalData, () => undefined);
        }
    }
    onSignalState(connection, state) {
        connection.setState(state);
        // Ensure downstream bindings re-run when the provider pushes new connection state
        this.videoProvider.notifyStreamStateChange();
    }
    onSignalConstraintsApplied(connection) {
        const stream = connection.streams.find((str) => str.type === 'camera');
        if (stream) {
            stream.onConstraintsApplied();
        }
    }
}
